module.exports = "<div [(emojiPickerIf)]=\"toggled\" [emojiPickerDirection]=\"'top'\"\n    (emojiPickerSelect)=\"handleSelection($event)\">\n<div>\n"